import { QUESTIONNAIRE_EVALUATION as MODULE_PREFIX } from '../constants';
export const QUESTIONNAIRE_EVALUATION_GET_REQUEST = `${MODULE_PREFIX}_GET_REQUEST`;
export const QUESTIONNAIRE_EVALUATION_GET_REQUEST_SUCCESS = `${MODULE_PREFIX}_GET_REQUEST_SUCCESS`;
export const questionnaireEvaluationGetRequestAction = requestData => ({
    type: QUESTIONNAIRE_EVALUATION_GET_REQUEST,
    payload: requestData
});
export const questionnaireEvaluationGetRequestSuccessAction = requestData => ({
    type: QUESTIONNAIRE_EVALUATION_GET_REQUEST_SUCCESS,
    payload: requestData
});
//# sourceMappingURL=questionnaireEvaluationGetActions.js.map